"use client";
import styled from "styled-components";

export const Title = styled.div`
  font-size: 32px;
  line-height: 48px;
  font-variation-settings: "wght" 700;
  text-align: left;
  @media (min-width: 768px) {
    text-align: center;
  }
  @media (min-width: 1024px) {
    font-size: 40px;
    &.withdraw {
      white-space: nowrap;
    }
  }
`;
export const TitleWrapper = styled.div`
  padding: 0 24px;
`;

export const Available = styled.div`
  font-size: 16px;
  line-height: 24px;
  color: #72706e;
  @media (min-width: 768px) {
    text-align: center;
  }
`;

export const InputBox = styled.div`
  span {
    position: relative;
    height: 20px;
    background: transparent;
  }

  .input {
    border: none;
    outline: none;
    padding: 0;
    margin: 0;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 20px;
    background: transparent;
    caret-color: var(--text-primary);
    color: transparent;
    &::-ms-clear {
      display: none;
    }

    &__area {
      transition: 300ms ease-out;
      padding: 10px 14px;
      background: var(--fill-secondary);
      border-radius: 16px;
      min-height: 60px;
      box-shadow: inset 0 0 0 2px transparent;
    }
    &__hint {
      color: var(--text-secondary);
      font-size: 12px;
      line-height: 16px;
      letter-spacing: 0.5px;
      transition: 300ms ease-out;
    }
  }
  .suggestions {
    content: " ";
    height: 34px;
    gap: 6px;
    margin-top: 7px;
    display: flex;
    opacity: 0;
    pointer-events: none;
    &__item {
      cursor: pointer;
      box-shadow: 0px 2px 1px rgba(51, 20, 0, 0.04),
        0px 4px 8px rgba(51, 20, 0, 0.08);
      border-radius: 16px;
      letter-spacing: 0.03em;
      font-variation-settings: "wght" 700;
      padding: 4px 8px;
      height: 32px;
      background: var(--fill-elevated);
      color: var(--text-primary);
    }
  }

  &.focused {
    .input {
      &__area {
        background: transparent;
        box-shadow: inset 0 0 0 2px var(--border-focus);
      }
    }
    .suggestions {
      opacity: 1;
      pointer-events: all;
    }
  }

  &.error {
    .input {
      &__area {
        background: var(--fill-negative-bg);
        box-shadow: inset 0 0 0 1px var(--border-negative);
      }
      &__hint {
        color: var(--border-negative);
      }
    }
  }

  &.pending {
    pointer-events: none;
    background: transparent;
    caret-color: #000;
    border: 0;
    outline: 0;
    .input {
      pointer-events: none;
    }
  }
`;

export const ButtonWide = styled.button`
  border: 0;
  outline: 0;
  border-radius: 16px;
  height: 64px;
  background: #f7f3f2;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-variation-settings: "wght" 700;
  line-height: 20px;
  letter-spacing: 0.03em;
  width: 100%;
  cursor: pointer;

  &.button--black {
    color: #fff;
    background: #000000;
  }
`;

export const InfoRow = styled.div<{ $error?: boolean; $inactive?: boolean }>`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  font-style: normal;
  font-weight: 500;
  font-variation-settings: "wght" 500;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.01em;
  opacity: ${({ $inactive }) => ($inactive ? 0.24 : 1)};

  & > *:last-child {
    text-align: right;
  }

  div.label {
    margin-bottom: 16px;
  }

  .value {
    color: ${({ $error }) =>
      $error ? "var(--text-negative)" : "var(--text-primary)"};
  }

  div.line-through {
    font-style: normal;
    font-weight: 500;
    font-variation-settings: "wght" 500;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.5px;
    text-decoration-line: line-through;
    color: #72706e;
    text-align: right;
  }
`;

export const ClearButtonWrapper = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 80px;
`;

export const BonusSection = styled.div`
  gap: 8px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  max-width: 332px;
`;
